export const items = [
  {
    key: "all",
    label: "All transactions",
  },
  {
    key: "income",
    label: "Income",
  },
  {
    key: "expense",
    label: "Expense",
  },
];

export const dataSource = [
  {
    id: 12548796,
    description: "Spotify Subscription",
    type: "Shopping",
    card: "1234 4444 3333 5555",
    date: "28 Jan, 12.30 AM",
    amount: "-$100",
    status: "expense",
    receipt:
      "https://pixso.net/app/editor/RzGe0tprVbjl4Mu-eTH7FQ?icon_type=1&page-id=0%3A1&editMode=coder",
  },
  {
    id: 35648796,
    description: "Freepik Sales",
    type: "Transfer",
    card: "1234 4444 3333 5555",
    date: "25 Jan, 10.40 PM",
    amount: "$300",
    status: "income",
    receipt:
      "https://pixso.net/app/editor/RzGe0tprVbjl4Mu-eTH7FQ?icon_type=1&page-id=0%3A1&editMode=coder",
  },
  {
    id: 99998796,
    description: "Mobile Service",
    type: "Service",
    card: "1234 4444 3333 5555",
    date: "20 Jan, 10.40 PM",
    amount: "-$2,500",
    status: "expense",
    receipt:
      "https://pixso.net/app/editor/RzGe0tprVbjl4Mu-eTH7FQ?icon_type=1&page-id=0%3A1&editMode=coder",
  },
  {
    id: 55228796,
    description: "Wilson",
    type: "Transfer",
    card: "1234 4444 3333 5555",
    date: "15 Jan, 03.29 PM",
    amount: "$1,500",
    status: "income",
    receipt:
      "https://pixso.net/app/editor/RzGe0tprVbjl4Mu-eTH7FQ?icon_type=1&page-id=0%3A1&editMode=coder",
  },
  {
    id: 55228796,
    description: "Emilly",
    type: "Transfer",
    card: "1234 4444 3333 5555",
    date: "14 Jan, 10.40 PM",
    amount: "$1,500",
    status: "income",
    receipt:
      "https://pixso.net/app/editor/RzGe0tprVbjl4Mu-eTH7FQ?icon_type=1&page-id=0%3A1&editMode=coder",
  },
];
